<template>
  <filter-select
    :disabled="disabled"
    :value="value"
    @input="(e) => $emit('input', e)"
    :addNewEnable="true"
    @addNew="addNew"
    :label="label"
    :hide-label="hideLabel"
    :placeholder="placeholder"
    :options="options_units[unit_param]"
  />
</template>

<script>
import FilterSelect from '../../../components/FilterSelect';
import work_units from '../../../data/work_units';
import {getUnits} from '../../../firestore/units';
import firebase from 'firebase';

export default {
  name: 'unitSelect',
  components: {FilterSelect},
  props: {
    placeholder: {
      type: String,
      default: null,
    },
    disabled: Boolean,
    hideLabel: {
      type: Boolean,
    },
    unit_param: {
      default: 'main',
      type: String,
    },
    label: {
      default: 'Ед. изм.',
      type: String,
    },
    value: [String, Object],
  },
  data() {
    return {
      options_units: {
        main: [],
        tech: work_units.tech,
      },
    };
  },
  async mounted() {
    this.options_units.main = await getUnits(this.$store.state.project.id);
  },
  methods: {
    async addNew(add) {

      const units_r = await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('units')
        .orderBy("index", 'desc').limit(1)
        .get();

      let units = {
        index: 0
      };

      units_r.forEach((subDoc) => {
        units = subDoc.data();
      });

      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('units')
        .add({
          index: (units.index || 0) + 1,
          name: add,
        }).then((docRef) => {
        this.options_units = {
          ...this.options_units,
          tech: [
            ...this.options_units.tech, {
              label: add,
              value: docRef.id,
            }],
        };
        setTimeout(() => {
          this.$emit('input', {
            label: add,
            value: docRef.id,
          });
        }, 500);
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Добавлено',
          type: 'success',
        });
      });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/components/unitSelect.vue